module.exports = __webpack_public_path__ + "assets/img/cpnews37.1bb9830b.png";